import { useColorScheme } from "@/hooks/useColorScheme";
import logo from "@/logo-ncm.png";
import { MeteomaticsLogo, MeteomaticsLogoPositive } from "@/meteomatics-logo";
import type React from "react";
import "./SideNavHeader.scss";

interface SideNavHeaderProps {
  showCustomLogo?: boolean | undefined;
}

export const SideNavHeader: React.FC<SideNavHeaderProps> = ({ showCustomLogo }: SideNavHeaderProps) => {
  const colorScheme = useColorScheme();

  return (
    <div className="side-nav-header">
      <div className="side-nav-header__top">
        <div className="side-nav-header__top-logo">
          {showCustomLogo ? (
            <img height="60" src={logo} alt="logo ncm" />
          ) : colorScheme === "dark" ? (
            <MeteomaticsLogo />
          ) : (
            <MeteomaticsLogoPositive />
          )}
        </div>
      </div>
    </div>
  );
};
